import React from "react";
import "./nav.css"
import {Link} from "react-router-dom";

const VideoDetail = ({video}) => {
    if (!video) {
        return <div> Loading...</div>
    }

    const videoSrc = `https://www.youtube.com/embed/${video.videoId}`;
    return (
        <div className="video-item">
            <div className="ui embed">
                <iframe title="video player" src={videoSrc}></iframe>
            </div>
            <div className="ui segment">
                <h4 className="ui header"> {video.title}</h4>
                <p>{video.description}</p>
                <button className="ui basic button">
                    <i className="icon user"></i>
                    <Link to={`/artist/${video.artist.id}`}>
                        {video.artist.name}
                    </Link>
                </button>
            </div>
        </div>
    );
};

export default VideoDetail;
